<template>
  <div class="app-form-field" :style="style">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppFormField',

  props: {
    width: {
      type: Number,
      default: 100,
    },
  },

  computed: {
    style() {
      const { width } = this;

      return {
        flex: `1 1 ${width}%`,
        maxWidth: `${width}%`,
      };
    }
  },
};
</script>

<style lang="scss">
.app-form-field {
  display: block;

  padding: inherit;

  @media screen and (max-width: 768px) {
    flex: 1 1 100% !important;
    max-width: 100% !important;
  }
}
</style>
